import { from, Observable } from 'rxjs';
import config from 'src/config';


// ====== PRIVATE UTILS ======

/**
 * Requests header generator
 */
export function httpHeader() {
  const header: any = {};

  // const currentState: RootState = store.getState();

  // if (currentState?.auth?.isAuthenticated) {
  //   APP_TOKEN = currentState.auth.accessToken;
  // }

  // if (APP_TOKEN) header.Authorization = `Bearer ${APP_TOKEN}`;
  // if (currentState?.auth?.xTenantUuid) header['X-TenantUUID'] = currentState?.auth?.xTenantUuid;

  return header;
}

function parseResponse(response: any) {
  return response.text().then((text: any) => {
    let data;

    try {
      data = text && JSON.parse(text);
    } catch (e) {
      data = null;
    }

    if (!response.ok) {
      if (!response.url.includes('/auth/login') && response.status === 401) {
        localStorage.clear();
        setTimeout(() => {
          window.location.href = '/';
        }, 100);
        throw response;
      }

      throw data;
    }

    return data;
  });
}

/**
 * GET request factory
 *
 * @param {string}    path          Resource path
 * @param {object}    params        Request query params
 * @param {boolean}   showLoader    Show global loader
 */
function GET(path: string): Observable<any> {
  const requestOptions = {
    method: 'GET',
    headers: httpHeader(),
  };

  let url = [config.REACT_APP_ADDRESS_SEARCH_URL, path].join('/');

  try {
    return from(
      fetch(url, requestOptions)
        .then(parseResponse)
        .catch((error) => {
          throw error;
        })
    );
  } catch (error) {
    throw error;
  }
}

/**
 * POST request factory
 *
 * @param {string}    path          Resource path
 * @param {object}    body          Request payload
 * @param {object}    params        Request query params
 * @param {boolean}   showLoader    Show global loader
 */
function POST(path: string, body: any): Observable<any> {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...httpHeader(),
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(body),
  };

  let url = [config.REACT_APP_ADDRESS_SEARCH_URL, path].join('/');

  return from(
    fetch(url, requestOptions)
      .then(parseResponse)
      .catch((error) => {
        throw error;
      })
  );
}

/**
 * PUT request factory
 *
 * @param {string}    path          Resource path
 * @param {object}    body          Request payload
 * @param {object}    params        Request query params
 */
function PUT(path: string, body: any): Observable<any> {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...httpHeader(),
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(body),
  };

  let url = [config.REACT_APP_ADDRESS_SEARCH_URL, path].join('/');

  return from(
    fetch(url, requestOptions)
      .then(parseResponse)
      .catch((error) => {
        throw error;
      })
  );
}

/**
 * PATCH request factory
 *
 * @param {string}    path          Resource path
 * @param {object}    body          Request payload
 * @param {object}    params        Request query params
 */
function PATCH(path: string, body: any): Observable<any> {
  const requestOptions = {
    method: 'PATCH',
    headers: {
      ...httpHeader(),
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(body),
  };

  let url = [config.REACT_APP_ADDRESS_SEARCH_URL, path].join('/');

  return from(
    fetch(url, requestOptions)
      .then(parseResponse)
      .catch((error) => {
        throw error;
      })
  );
}

/**
 * DELETE request factory
 *
 * @param {string}    path          Resource path
 * @param {object}    params        Request query params
 * @param {boolean}   hideLoader    Hide global loader
 */
function DELETE(path: string): Observable<any> {
  const requestOptions = {
    method: 'DELETE',
    headers: httpHeader(),
  };

  let url = [config.REACT_APP_ADDRESS_SEARCH_URL, path].join('/');

  return from(
    fetch(url, requestOptions)
      .then(parseResponse)
      .catch((error) => {
        throw error;
      })
  );
}

/**
 * POST request factory with JSON Patch content type
 *
 * @param {string}    path          Resource path
 * @param {object}    body          Request payload
 * @param {object}    params        Request query params
 */
function POSTJsonPatch(path: string, body: any): Observable<any> {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...httpHeader(),
      'Content-Type': 'application/json-patch+json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(body),
  };

  let url = [config.REACT_APP_ADDRESS_SEARCH_URL, path].join('/');

  return from(
    fetch(url, requestOptions)
      .then(parseResponse)
      .catch((error) => {
        throw error;
      })
  );
}

export default {
  GET,
  POST,
  PUT,
  PATCH,
  DELETE,
  POSTJsonPatch,
};
